import { useCallback, useEffect, useState } from "react";
import { Plus, Wallet } from "lucide-react";
import {
  abrirCarteira,
  aoAtualizarCarteira,
  getCarteira,
} from "services/carteira/carteira.service";

const brl = (v: number) =>
  v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/**
 * Saldo da carteira no cabeçalho. Clicar abre a carteira (modal no
 * AppSidebar) já na recarga. Some para contas sem carteira liberada.
 */
const SaldoCarteira = () => {
  const [saldo, setSaldo] = useState<number | null>(null);

  const carregar = useCallback(() => {
    getCarteira()
      .then((r) => setSaldo(r.habilitada ? r.saldo : null))
      .catch(() => setSaldo(null));
  }, []);

  useEffect(() => {
    carregar();
    // Atualiza quando uma recarga confirma e quando a aba volta ao foco
    // (o PIX costuma ser pago no celular, com o site em segundo plano).
    const tirar = aoAtualizarCarteira(carregar);
    const foco = () => document.visibilityState === "visible" && carregar();
    document.addEventListener("visibilitychange", foco);
    return () => {
      tirar();
      document.removeEventListener("visibilitychange", foco);
    };
  }, [carregar]);

  if (saldo === null) return null;

  const zerado = saldo <= 0;

  return (
    <button
      type="button"
      onClick={abrirCarteira}
      title="Abrir carteira e adicionar saldo"
      className={`group flex h-12 items-center gap-3 rounded-xl border pl-3 pr-2 text-left transition-colors ${
        zerado
          ? "border-amber-300 bg-amber-50 hover:border-amber-400"
          : "border-slate-200 bg-white hover:border-brand-sidebar/40"
      }`}
    >
      <span
        className={`grid h-8 w-8 place-items-center rounded-lg ${
          zerado ? "bg-amber-100 text-amber-700" : "bg-brand-sidebar/10 text-brand-sidebar"
        }`}
      >
        <Wallet className="h-4 w-4" />
      </span>
      <span className="leading-tight">
        <span className="block text-[10px] font-semibold uppercase tracking-wider text-slate-500">
          Saldo carteira
        </span>
        <span
          className={`block text-base font-extrabold tabular-nums ${
            saldo < 0 ? "text-red-600" : "text-brand-sidebar"
          }`}
        >
          {brl(saldo)}
        </span>
      </span>
      <span
        className={`ml-1 flex h-8 items-center gap-1 rounded-lg px-2 text-xs font-bold transition-colors ${
          zerado
            ? "bg-amber-500 text-white"
            : "bg-slate-100 text-brand-sidebar group-hover:bg-brand-sidebar group-hover:text-white"
        }`}
      >
        <Plus className="h-4 w-4" />
        <span className="hidden sm:inline">Adicionar</span>
      </span>
    </button>
  );
};

export default SaldoCarteira;
